import React from 'react';
import { BaseSpin } from '@components/spin';
import { useMounted } from '@hooks/useMounted.ts';
import { BarChart, LineChart } from 'echarts/charts';
import { GridComponent, LegendComponent, TitleComponent, TooltipComponent } from 'echarts/components';
// 2. Import ECharts “core” plus only the charts, components and renderer you need
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import type { EChartsOption } from 'echarts-for-react';
// 1. Use the “core” build of the React wrapper
import ReactEChartsCore from 'echarts-for-react/lib/core';
// 3. Register them with the core
echarts.use([BarChart, LineChart, TitleComponent, TooltipComponent, GridComponent, LegendComponent, CanvasRenderer]);

// use for full react charts version
// import ReactECharts from 'echarts-for-react';

export interface BaseChartProps {
    option?: EChartsOption;
    onEvents?: Record<string, (e: any) => void>;
    width?: string | number;
    height?: string | number;
    style?: React.CSSProperties;
}

export const BaseChart: React.FC<BaseChartProps> = ({ option, width, height, onEvents, style, ...props }) => {
    const isMounted = useMounted();
    const chartHeight = height || '400px';

    if (!isMounted.current) {
        return <BaseSpin size="medium" />;
    }

    return (
        <ReactEChartsCore
            echarts={echarts}
            option={option}
            style={{
                ...style,
                height: chartHeight,
                minHeight: height === '100%' ? 400 : undefined,
                width,
                zIndex: 0,
            }}
            onEvents={onEvents}
            {...props}
        />
    );
};
